import React from 'react';
import { Button, ButtonProps, Progress } from '@carrotfertility/carotene-core';
import { useFormState } from 'react-hook-form';

const loadingButton = <Progress data-testid="button-loading" size="1.25rem" color="inherit" />;

type IconLoadingState = {
    children: React.ReactNode;
    endIcon?: React.ReactNode;
    startIcon?: React.ReactNode;
};

export type FormButtonProps = ButtonProps;

export function FormButton(props: FormButtonProps) {
    const state = useFormState();

    const { endIcon, startIcon, children } = React.useMemo(() => {
        if (props?.type !== 'submit') {
            return {
                children: props?.children,
                endIcon: props?.endIcon,
                startIcon: props?.startIcon,
            };
        }
        const iconState: IconLoadingState = { children: state?.isSubmitting ? loadingButton : props.children };
        if (props?.endIcon) {
            iconState.children = props.children;
            iconState.endIcon = state?.isSubmitting ? loadingButton : props?.endIcon;
        }
        if (props?.startIcon) {
            iconState.children = props.children;
            iconState.startIcon = state?.isSubmitting ? loadingButton : props?.startIcon;
        }
        return iconState;
    }, [props.children, props?.endIcon, props?.startIcon, props?.type, state?.isSubmitting]);

    return (
        <Button {...props} {...{ endIcon, startIcon }} disabled={state.isSubmitting || props?.disabled}>
            {children}
        </Button>
    );
}
